export const SUBSCRIBE_MAIL_START = 'SUBSCRIBE_MAIL_START';

export const SUBSCRIBE_MAIL_SUCCESS = 'SUBSCRIBE_MAIL_SUCCESS';

export const SUBSCRIBE_MAIL_FAILED = 'SUBSCRIBE_MAIL_FAILED';
